export namespace OrganizationsProps {
  export interface Instance {
    id: string
    hostname: string
  }
  export interface Organization {
    id: string
    instance: Instance
    caratOrgName: string
    name: string
  }

  export interface OrganizationPUT {
    instanceId: any
    caratOrgName: any
    name: any
  }

  export interface Component {
    data: Organization[]
    sort: any
    sortChange: any
    SELECTED_FIELD: any
    selectedState: any
    setSelectedState?: any
    idGetter: any
    onSelectChange: any
    onSelectionChange: any
    onHeaderSelectionChange: any
    addOrganization: any
    deleteOrganization: any
    handleConfirmDelete: any
    confirmDeleteMessage: string
    setConfirmDeleteMessage?: any
    showDialog: any
    toggleDialog: () => any
    shouldDisableButton: any
    shouldDisableEdit: any
    fetchData: () => any
    accessToken: any
    pageSizeValue: number
    pageChange: (e) => any
    page: any
    isEditing?: boolean
    setEditData?: any
    setIsEditing?: any
    setPageSizeValue?: any
    selectionMode?: any
    setData?: any
    hasTruthyValue?: any
    parseSort?: (e) => any
    editOrganization: any
    editData: Organization
    isSelected?: any
    setIsSelected?: any
    isCheckboxSelected?: any
    setIsCheckboxSelected?: any
    filter?: any
    handleFilter?: any
    setFilter?: any
  }

  export interface DialogType {
    fetchData: () => any
    toggleDialog: () => any
    accessToken: any
    isEditing: boolean
    showDialog: boolean
    clearCheckbox?: () => any
    resetState: () => any
    handleClear: (field: any) => any
    create: any
    handleChange: any
    changes: boolean
    update: any
    setChanges?: any
    instanceList?: any
    instanceData?: any
  }

  export const Helper: any = {
    itemsToDelete: [],
    itemPutID: '',
    pagination: {
      page: 0,
      pages: 1,
      perPage: 20,
      total: 20,
    },
    hasAccessToken: false,
    filters: [],
  }
}
